export default "__VITE_ASSET__5ae2bfd6__"